<template>
  <div class="container container-footer">
    <footer class="footer">
      <div class="footer-item" :class="{ active: isActive('HomeView') }" @click="actionRoute('Home')">
        <i class="material-icons">home</i>
        <span>Home</span>
      </div>
      <div class="footer-item" :class="{ active: isActive('history-view') }" @click="actionRoute('Pemesanan')">
        <i class="material-icons">receipt</i>
        <span>Pemesanan</span>
      </div>
      <div class="footer-item emergency" :class="{ active: isActive('history-view') }" @click="redirectToWhatsApp()">
        <i class="material-icons">call</i>
        <span>Panggilan Darurat</span>
      </div>
      <div class="footer-item" :class="{ active: isActive('notification-view') }" @click="actionRoute('Notifikasi')">
        <i class="material-icons">message</i>
        <span>Notifikasi</span>
        <span v-if="unreadNotifications > 0" class="notification-badge">{{ unreadNotifications }}</span>
      </div>
      <div class="footer-item" :class="{ active: isActive('profile-view') }" @click="actionRoute('Profile')">
        <i class="material-icons">person</i>
        <span>Akun</span>
      </div>
    </footer>
    <alert-popup :alertData="alertData" @closeAlert="closeAlert"></alert-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import echo from "@/controllers/echo";
import storage from "@/controllers/storage";
import AlertPopup from "./AlertPopup.vue";
import { trackEvent } from "@/utils/analytics";

export default {
  name: "AppFooter",
  components: {
    AlertPopup,
  },
  data() {
    return {
      notifications: [],
      session: {},

      //Alert
      alertData: {
        alertShow: false,
        alertTitle: "",
        alertMessage: "",
      },
    };
  },
  async mounted() {
    this.session = storage.getLocalStorage();
    if (this.session.token) {
      let data_req = {
        memberId: this.session.memberId,
      };
      await this.fetchDataNotif(data_req);

      echo.channel(`USR-RK.${this.session.memberId}`).listen("NotificationUserRK", (data) => {
        if (data) {
          let data_req = {
            memberId: this.session.memberId,
          };
          this.fetchDataNotif(data_req);
        }
      });
    }
  },
  methods: {
    async actionRoute(route) {
      trackEvent("bottom_nav_click", { nav_target: route.toLowerCase() });
      if (route == "Home") {
        this.$router.push({ name: "HomeView" });
      } else if (route == "Pemesanan") {
        if (this.session.memberId) {
          this.$router.push({ name: "history-view" });
        } else {
          this.alertData.alertShow = true;
          this.alertData.alertTitle = "Peringatan";
          this.alertData.alertMessage = "Anda belum login! Silahkan login terlebih dahulu!";
        }
      } else if (route == "Notifikasi") {
        this.$router.push({ name: "notification-view" });
      } else if (route == "Profile") {
        this.$router.push({ name: "profile-view" });
      }
    },
    isActive(routeName) {
      return this.$route.name === routeName;
    },

    async closeAlert() {
      this.alertData.alertShow = false;
    },

    redirectToWhatsApp() {
      trackEvent("bottom_nav_click", { nav_target: "emergency" });
      const formattedNumber = "+6285320002020";
      const encodedPhoneNumber = encodeURIComponent(formattedNumber);
      const whatsappURL = `https://wa.me/${encodedPhoneNumber}`;
      window.open(whatsappURL, "_blank");
    },

    ...mapActions({
      fetchDataNotif: "user/fetchNotif",
    }),

    ...mapMutations({
      setNotif: "user/setNotif",
    }),
  },
  computed: {
    unreadNotifications() {
      return this.dataNotif.filter((notification) => notification.is_read == 0).length;
    },

    ...mapGetters("user", {
      dataNotif: "get_res_notif",
    }),
  },
};
</script>
